import React from 'react';
import { Button, Card, Form, Input, message, Spin, Switch, Icon, Tooltip } from 'antd';
import CkInfoItem from "../../components/CkInfoItem";
import { fetchEvt } from "../../redux/actions/evt";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { inEditMode } from "../../redux/actions/global";
import { updateEventPromote } from "../../services/evt";
import CkUpload from "../../components/CkUpload";
import DefaultPromoteLogo from '../../style/imgs/invitation-page/qrcod.png'
import classnames from 'classnames'


const mapStateToPorps = state => {
    const cmEnums = state.cmEnums;
    return { cmEnums };
};
const mapDispatchToProps = dispatch => ({
    fetchEvt: bindActionCreators(fetchEvt, dispatch),
});


class EvtViewPromoteForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            formLoading: false
        }
    }

    componentDidMount() {
        this.mounted = true;
    }

    componentWillUnmount() {
        this.mounted = false;
    }

    intoEdit = () => {
        this.props.editableChange(this.props.editableStatePropName, true)
    }
    cancelEdit = () => {
        this.props.editableChange(this.props.editableStatePropName, false)
    }
    save = () => {
        this.props.form.validateFieldsAndScroll((error, values) => {
            if (!error) {
                this.changeFormLoading(true);
                const that = this;
                updateEventPromote(Object.assign({ id: this.props.evt.header.id }, values)).then(res => {
                    if (res.code == 200) {
                        message.info("更新成功!");
                        that.props.editableChange(this.props.editableStatePropName, false, true)
                    } else {
                        message.error(res.msg,6);
                    }
                }).catch(err => {
                    message.warn("访问异常");
                }).finally(() => {
                    that.changeFormLoading(false)
                })
            } else {
                console.log('error', error, values);
            }
        });
    }

    changeFormLoading = (loading) => {
        if (this.mounted) {
            this.setState({
                formLoading: loading
            })
        }
    }

    render() {
        const evt = this.props.evt;

        const { getFieldDecorator, getFieldValue, getFieldError } = this.props.form;

        const editableTools = this.props.editable ?
            <div className="evt-create-editable-tools">
                <Button type="primary" size="small" onClick={this.save}>保存</Button>
                <Button type="primary" size="small" ghost onClick={this.cancelEdit}>放弃</Button>
            </div>
            :
            <div className="evt-create-editable-tools" onClick={this.props.vaild ? this.intoEdit : this.props.show}>
                <Button type="primary" size="small" ghost>编辑</Button>
            </div>


        const promoteLogo = evt.header.promoteLogo && evt.header.promoteLogo != "removed" ? evt.header.promoteLogo : DefaultPromoteLogo
        const promoteDesc = evt.header.promoteDesc ? (evt.header.promoteDesc == "removed" ? "" : evt.header.promoteDesc) : "可以查看您报名、签到情况和接收最新资讯"
        return (
            <Form>
                <Spin spinning={this.state.formLoading}>
                    <Card bodyStyle={{ padding: "16px" }}>
                        {editableTools}
                        {
                            <CkInfoItem label={<div>
                                &nbsp;
                                <span>
                                    上传LOGO（如：公众号或微信群 二维码等，建议200*200像素）
                                    <span>
                                        <Tooltip placement="bottom" overlayClassName='overlay-image'
                                            mouseEnterDelay={0.3} title={
                                                <div>
                                                    购买会员，签到家的LOGO和广告会去掉，可以在这里指定您自己的LOGO和宣传语 <a href="https://www.yuque.com/odh2xi/manual/rdi3faeuc977n8vu#UVUJ9" target="_Blank" >  详细帮助</a>
                                                </div>
                                            }>
                                            <Icon type="question-circle-o" />
                                        </Tooltip>
                                    </span></span>
                            </div>} contentIndent={false}>
                                <div style={{ width: "100%", height: "100px" }}>
                                    {
                                        this.props.editable ?
                                            getFieldDecorator('promoteLogo', {
                                                initialValue: promoteLogo,
                                                getValueFromEvent: (fileUrlObj) => {
                                                    return fileUrlObj.url ? fileUrlObj.url : '';
                                                }
                                            })(
                                                <CkUpload
                                                    width={100}
                                                    height={100}
                                                />
                                            )
                                            :
                                            <img style={{ width: 100, height: 100 }} src={promoteLogo} />
                                    }
                                </div>
                            </CkInfoItem>
                        }
                        {
                            <CkInfoItem label={"文字介绍"}>
                                {
                                    this.props.editable ?
                                        getFieldDecorator('promoteDesc', {
                                            initialValue: promoteDesc,
                                            rules: [
                                                { required: false, message: '活动推广介绍为必填项' },
                                                { type: "string", min: 2, max: 50, message: '长度限制为2至50个之间!' }
                                            ],
                                        })(
                                            <Input placeholder="文字描述，最多50字，如：请关注本活动主办方公众号，获得更多资讯" />
                                        )
                                        :
                                        promoteDesc
                                }
                            </CkInfoItem>
                        }

                        {/* <CkInfoItem label={"活动详情是否展示"}>
                            {
                                this.props.editable ?
                                    getFieldDecorator('showQrCode', {
                                        initialValue: evt.header.showQrCode,
                                        valuePropName: 'checked',
                                    })(
                                        <Switch checkedChildren={'是'}
                                            unCheckedChildren={'否'}

                                        />
                                    )
                                    :
                                    <span className={classnames("evt-config-item", {
                                        'mdc-text-green': evt.header.showQrCode,
                                        'text-error': !evt.header.showQrCode
                                    })}>
                                        {evt.header.showQrCode ? '是' : '否'}
                                    </span>
                            }
                        </CkInfoItem> */}

                        <CkInfoItem label={"参与人报名后弹出"}>
                            {
                                this.props.editable ?
                                    getFieldDecorator('signUpOpen', {
                                        initialValue: evt.header.signUpOpen,
                                        valuePropName: 'checked',
                                    })(
                                        <Switch checkedChildren={'开启'}
                                            unCheckedChildren={'关闭'}

                                        />
                                    )
                                    :
                                    <span className={classnames("evt-config-item", {
                                        'mdc-text-green': evt.header.signUpOpen,
                                        'text-error': !evt.header.signUpOpen
                                    })}>
                                        {evt.header.signUpOpen ? '开启' : '关闭'}
                                    </span>
                            }
                        </CkInfoItem>
                        <CkInfoItem label={"参与人扫码签到后弹出"}>
                            {
                                this.props.editable ?
                                    getFieldDecorator('signInOpen', {
                                        initialValue: evt.header.signInOpen,
                                        valuePropName: 'checked',
                                    })(
                                        <Switch checkedChildren={'开启'}
                                            unCheckedChildren={'关闭'}

                                        />
                                    )
                                    :
                                    <span className={classnames("evt-config-item", {
                                        'mdc-text-green': evt.header.signInOpen,
                                        'text-error': !evt.header.signInOpen
                                    })}>
                                        {evt.header.signInOpen ? '开启' : '关闭'}
                                    </span>
                            }
                        </CkInfoItem>

                    </Card>
                </Spin>
            </Form>
        )
    }
}


EvtViewPromoteForm.contextTypes = {}

EvtViewPromoteForm.defaultProps = {
    evt: {},
    editableStatePropName: null,
    confDesArr: [],
    editable: false,
    editableChange: (editable, dataChanged = false) => null,
}

EvtViewPromoteForm.propTypes = {}


export default connect(mapStateToPorps, mapDispatchToProps)(Form.create()(EvtViewPromoteForm));


// WEBPACK FOOTER //
// ./src/containers/evt/EvtViewPromoteForm.jsx